import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import Component from "@reactions/component";
import { Dialog } from 'evergreen-ui';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, Card, Button, Container, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Login from '../common/login';
import moment from "moment-timezone";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';

import 'react-toastify/dist/ReactToastify.css';
const cookies = new Cookies();

// Inline Styles
const styles = {
    pageContainer: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)',
        paddingBottom: '3rem'
    },
    headerSection: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '2rem 0',
        marginBottom: '2rem',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
    },
    headerTitle: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        marginBottom: '1rem',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem'
    },
    statsCard: {
        borderRadius: '20px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        border: 'none',
        transition: 'all 0.3s ease',
        overflow: 'hidden',
        height: '100%',
        cursor: 'pointer',
        background: 'white'
    },
    statsCardHover: {
        transform: 'translateY(-5px)',
        boxShadow: '0 15px 40px rgba(0,0,0,0.15)'
    },
    cardHeader: {
        padding: '1.5rem',
        borderBottom: '1px solid rgba(0,0,0,0.05)',
        background: 'rgba(0,0,0,0.02)'
    },
    cardBody: {
        padding: '2rem',
        textAlign: 'center'
    },
    cardTitle: {
        fontSize: '1.1rem',
        fontWeight: '600',
        marginBottom: '0.5rem',
        color: '#495057'
    },
    cardValue: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        marginBottom: '0'
    },
    iconWrapper: {
        width: '60px',
        height: '60px',
        borderRadius: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 1rem',
        color: 'white'
    },
    incomeIcon: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    expenseIcon: {
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    shippingIcon: {
        background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    },
    purchaseIcon: {
        background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
    },
    paymentIcon: {
        background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)'
    },
    remainingIcon: {
        background: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)'
    },
    summaryCard: {
        background: 'white',
        borderRadius: '20px',
        padding: '2rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        marginBottom: '2rem'
    },
    summaryTitle: {
        fontSize: '1.8rem',
        fontWeight: 'bold',
        marginBottom: '2rem',
        color: '#2c3e50',
        textAlign: 'center'
    },
    tableContainer: {
        background: 'white',
        borderRadius: '20px',
        padding: '2rem',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
    },
    customTable: {
        borderRadius: '15px',
        overflow: 'hidden'
    },
    tableHeader: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontWeight: '600'
    },
    tableRow: {
        transition: 'all 0.3s ease'
    },
    tableRowHover: {
        background: '#f8f9fa',
        transform: 'scale(1.01)'
    },
    closeButton: {
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        border: 'none',
        borderRadius: '30px',
        padding: '12px 30px',
        fontWeight: '600',
        fontSize: '1.1rem',
        transition: 'all 0.3s ease',
        boxShadow: '0 5px 15px rgba(240, 87, 108, 0.3)'
    },
    closeButtonHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 20px rgba(240, 87, 108, 0.4)'
    }
};

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Getid: "",
            remaining_amount: 0,
            ShippingPayment: 0,
            Spending: 0,
            purchase_list: 0,
            supplier_payments: 0,
            remaining_now: 0,
            data: [],
            hoveredCard: null,
            currentPage: 1,
            itemsPerPage: 10
        }

        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        this.setState({ Getid: Getid })
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };

        axios.get(host + `dashbord/get/momny`, { headers: header })
            .then(res => {
                let income = res.data.ShippingPayment + res.data.remaining_amount;
                let outcome = res.data.Spending + res.data.purchase_list + res.data.supplier_payments;
                this.setState({
                    ShippingPayment: res.data.ShippingPayment,
                    Spending: res.data.Spending,
                    purchase_list: res.data.purchase_list,
                    supplier_payments: res.data.supplier_payments,
                    remaining_amount: res.data.remaining_amount,
                    remaining_now: income - outcome
                })
            })
            .catch(error => { console.log(error.response) })

        axios.get(host + `dashbord/safe/mtabka`, { headers: header })
            .then(res => {
                let safe = res.data.safe;
                let arry = []
                for (let index = 0; index < safe.length; index++) {
                    // إرجاع البيانات كـ object للاستخدام في الجدول العادي
                    let obj = {
                        id: safe[index].id,
                        Spending_amount: safe[index].Spending_amount,
                        purchase__amount: safe[index].purchase__amount,
                        remaining_amount: safe[index].remaining_amount,
                        shippingPayment_amount: safe[index].shippingPayment_amount,
                        supplier_payments_amount: safe[index].supplier_payments_amount,
                        createdAt: moment(safe[index].createdAt).format('DD/MM/YYYY'),
                    }
                    arry.push(obj);
                }
                this.setState({ data: arry })
            })
            .catch(error => { console.log(error.response) })
    }

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    textAlign: 'right',
                    padding: '16px',
                },
            },
            MuiTableCell: {
                root: {
                    textAlign: 'right',
                    borderBottom: '1px solid #e0e0e0',
                },
                head: {
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '1rem',
                    padding: '20px 16px',
                }
            },
            MUIDataTableHeadCell: {
                root: {
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white !important',
                }
            },
            MUIDataTableToolbar: {
                root: {
                    padding: '16px 24px',
                    background: '#f8f9fa',
                    borderRadius: '20px 20px 0 0',
                }
            },
            MUIDataTable: {
                paper: {
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    borderRadius: '20px',
                    overflow: 'hidden',
                }
            },
        }
    })

    add_payment() {
        var header = { "Content-Type": "application/x-www-form-urlencoded", Authorization: cookies.get("tokenUser") };
        axios.post(host + `dashbord/safe/mtabka`)
            .then(response => {
                window.location.reload();
            })
            .catch(error => {});
    }

    // Pagination functions
    handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    }

    handleItemsPerPageChange = (event) => {
        this.setState({ 
            itemsPerPage: parseInt(event.target.value),
            currentPage: 1 // Reset to first page when items per page changes
        });
    }

    render() {
        if (cookies.get("token")) {
            // Calculate pagination values once
            const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
            const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
            const currentItems = this.state.data.slice(indexOfFirstItem, indexOfLastItem);
            const totalPages = Math.max(1, Math.ceil(this.state.data.length / this.state.itemsPerPage));
            
            return (
                <div style={styles.pageContainer}>
                    <ToastContainer />
                    <div id='navDashContiner'></div>
                    
                    {/* Header Section */}
                    <div style={styles.headerSection}>
                        <Container>
                            <div style={styles.headerTitle}>
                                💰 إدارة القاصة
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <Component initialState={{ isShown: false }}>
                                    {({ state, setState }) => (
                                        <React.Fragment>
                                            <Dialog
                                                isShown={state.isShown}
                                                title="مطابقة القاصة"
                                                intent="danger"
                                                onCloseComplete={() => setState({ isShown: false, delete: false })}
                                                confirmLabel="تاكيد"
                                                cancelLabel="الغاء"
                                                onConfirm={() => {
                                                    setState({ isShown: false })
                                                    this.add_payment()
                                                }}
                                            >
                                                <span id='msgDelete'>قبل عملية المطابقة تأكد عدم حدوث اي حركات مالية في النظام</span>
                                            </Dialog>
                                            <Button 
                                                style={styles.closeButton}
                                                onMouseEnter={(e) => Object.assign(e.target.style, styles.closeButtonHover)}
                                                onMouseLeave={(e) => Object.assign(e.target.style, styles.closeButton)}
                                                onClick={() => setState({ isShown: true })}
                                            >
                                                إغلاق القاصة
                                            </Button>
                                        </React.Fragment>
                                    )}
                                </Component>
                            </div>
                        </Container>
                    </div>

                    <Container>
                        {/* Stats Cards */}
                        <Row className="mb-4" dir="rtl">
                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'remaining' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'remaining' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.remainingIcon }}>
                                            <span style={{ fontSize: '2rem' }}>💵</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>المتبقى من أمس</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#667eea' }}>
                                            {this.state.remaining_amount.toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'shipping' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'shipping' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.shippingIcon }}>
                                            <span style={{ fontSize: '2rem' }}>🚚</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>دفوعات شركات التوصيل</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#4facfe' }}>
                                            {(this.state.ShippingPayment || 0).toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'expenses' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'expenses' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.expenseIcon }}>
                                            <span style={{ fontSize: '2rem' }}>📉</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>المصاريف</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#f5576c' }}>
                                            {(this.state.Spending || 0).toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'purchases' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'purchases' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.purchaseIcon }}>
                                            <span style={{ fontSize: '2rem' }}>🛒</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>المشتريات</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#43e97b' }}>
                                            {(this.state.purchase_list || 0).toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'supplier' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'supplier' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.paymentIcon }}>
                                            <span style={{ fontSize: '2rem' }}>💳</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>دفوعات التجار</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#fa709a' }}>
                                            {(this.state.supplier_payments || 0).toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col lg={4} md={6} className="mb-4">
                                <Card 
                                    style={{
                                        ...styles.statsCard,
                                        ...(this.state.hoveredCard === 'total' ? styles.statsCardHover : {})
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredCard: 'total' })}
                                    onMouseLeave={() => this.setState({ hoveredCard: null })}
                                >
                                    <Card.Body style={styles.cardBody}>
                                        <div style={{ ...styles.iconWrapper, ...styles.remainingIcon }}>
                                            <span style={{ fontSize: '2rem' }}>💰</span>
                                        </div>
                                        <h5 style={styles.cardTitle}>المتبقى في القاصة</h5>
                                        <h2 style={{ ...styles.cardValue, color: '#330867' }}>
                                            {(this.state.remaining_now || 0).toLocaleString()}
                                        </h2>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        {/* Previous Records Table */}
                        <Row className="justify-content-md-center" dir="rtl">
                            <Col>
                                <div style={styles.tableContainer}>
                                    <h3 style={styles.summaryTitle}>
                                        <span style={{ marginLeft: '10px', fontSize: '2rem' }}>📋</span>
                                        المطابقات السابقة
                                    </h3>
                                    
                                    {/* Items per page selector */}
                                    <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                        <label style={{ margin: 0, fontWeight: '600', color: '#495057' }}>عرض:</label>
                                        <select 
                                            value={this.state.itemsPerPage} 
                                            onChange={this.handleItemsPerPageChange}
                                            style={{ 
                                                width: '80px',
                                                borderRadius: '10px',
                                                border: '2px solid #e9ecef',
                                                fontWeight: '500',
                                                padding: '5px',
                                                outline: 'none'
                                            }}
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={20}>20</option>
                                            <option value={50}>50</option>
                                        </select>
                                        <span style={{ fontWeight: '600', color: '#495057' }}>سجل</span>
                                    </div>

                                    <div style={{ overflowX: 'auto' }}>
                                        <Table striped hover responsive style={{
                                            borderRadius: '15px',
                                            overflow: 'hidden',
                                            boxShadow: '0 0 20px rgba(0,0,0,0.05)'
                                        }}>
                                            <thead>
                                                <tr style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    color: 'white'
                                                }}>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>رقم القائمة</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>التاريخ</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>دفوعات التجار</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>دفوعات شركات التوصيل</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>المشتريات</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>المصاريف</th>
                                                    <th style={{ padding: '20px', textAlign: 'center', fontWeight: '600' }}>المتبقى</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.map((item, index) => (
                                                    <tr key={index} style={{
                                                        transition: 'all 0.3s ease',
                                                        cursor: 'pointer'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#f8f9fa';
                                                        e.currentTarget.style.transform = 'scale(1.01)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}>
                                                        <td style={{ textAlign: 'center', padding: '15px' }}>
                                                            <span style={{ 
                                                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                color: 'white',
                                                                padding: '5px 15px',
                                                                borderRadius: '20px',
                                                                fontWeight: '600',
                                                                display: 'inline-block'
                                                            }}>
                                                                #{item.id}
                                                            </span>
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', fontWeight: '500', color: '#495057' }}>
                                                            {item.createdAt}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', color: '#fa709a', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                                            {item.supplier_payments_amount.toLocaleString()}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', color: '#4facfe', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                                            {item.shippingPayment_amount.toLocaleString()}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', color: '#43e97b', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                                            {item.purchase__amount.toLocaleString()}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', color: '#f5576c', fontWeight: 'bold', fontSize: '1.1rem' }}>
                                                            {item.Spending_amount.toLocaleString()}
                                                        </td>
                                                        <td style={{ textAlign: 'center', padding: '15px', color: '#30cfd0', fontWeight: 'bold', fontSize: '1.2rem' }}>
                                                            {item.remaining_amount.toLocaleString()}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {currentItems.length === 0 && (
                                                    <tr>
                                                        <td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#6c757d' }}>
                                                            لا توجد بيانات للعرض
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>

                                    {/* Pagination */}
                                    {this.state.data.length > 0 && (
                                        <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                                            {/* Showing results info */}
                                            <div style={{ 
                                                textAlign: 'center', 
                                                color: '#6c757d', 
                                                fontSize: '0.95rem',
                                                fontWeight: '500'
                                            }}>
                                                عرض {((this.state.currentPage - 1) * this.state.itemsPerPage) + 1} إلى {Math.min(this.state.currentPage * this.state.itemsPerPage, this.state.data.length)} من {this.state.data.length} سجل
                                            </div>
                                            
                                            {/* Pagination controls */}
                                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                <Button 
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => this.handlePageChange(1)}
                                                    disabled={this.state.currentPage === 1}
                                                    style={{ 
                                                        borderRadius: '10px',
                                                        fontWeight: '600',
                                                        padding: '8px 15px'
                                                    }}
                                                >
                                                    الأولى
                                                </Button>
                                                
                                                <Button 
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => this.handlePageChange(this.state.currentPage - 1)}
                                                    disabled={this.state.currentPage === 1}
                                                    style={{ 
                                                        borderRadius: '10px',
                                                        fontWeight: '600',
                                                        padding: '8px 15px'
                                                    }}
                                                >
                                                    السابق
                                                </Button>
                                                
                                                {(() => {
                                                    const pages = [];
                                                    const maxPagesToShow = 5;
                                                    let startPage = Math.max(1, this.state.currentPage - 2);
                                                    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
                                                    
                                                    if (endPage - startPage < maxPagesToShow - 1) {
                                                        startPage = Math.max(1, endPage - maxPagesToShow + 1);
                                                    }

                                                    if (startPage > 1) {
                                                        pages.push(
                                                            <Button
                                                                key={1}
                                                                variant={1 === this.state.currentPage ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => this.handlePageChange(1)}
                                                                style={{ 
                                                                    borderRadius: '10px',
                                                                    fontWeight: '600',
                                                                    padding: '8px 12px',
                                                                    minWidth: '40px',
                                                                    background: 1 === this.state.currentPage ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '',
                                                                    border: 1 === this.state.currentPage ? 'none' : ''
                                                                }}
                                                            >
                                                                1
                                                            </Button>
                                                        );
                                                        if (startPage > 2) {
                                                            pages.push(
                                                                <span key="ellipsis-start" style={{ padding: '0 10px', color: '#6c757d' }}>...</span>
                                                            );
                                                        }
                                                    }

                                                    for (let page = startPage; page <= endPage; page++) {
                                                        pages.push(
                                                            <Button
                                                                key={page}
                                                                variant={page === this.state.currentPage ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => this.handlePageChange(page)}
                                                                style={{ 
                                                                    borderRadius: '10px',
                                                                    fontWeight: '600',
                                                                    padding: '8px 12px',
                                                                    minWidth: '40px',
                                                                    background: page === this.state.currentPage ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '',
                                                                    border: page === this.state.currentPage ? 'none' : ''
                                                                }}
                                                            >
                                                                {page}
                                                            </Button>
                                                        );
                                                    }

                                                    if (endPage < totalPages) {
                                                        if (endPage < totalPages - 1) {
                                                            pages.push(
                                                                <span key="ellipsis-end" style={{ padding: '0 10px', color: '#6c757d' }}>...</span>
                                                            );
                                                        }
                                                        pages.push(
                                                            <Button
                                                                key={totalPages}
                                                                variant={totalPages === this.state.currentPage ? "primary" : "outline-primary"}
                                                                size="sm"
                                                                onClick={() => this.handlePageChange(totalPages)}
                                                                style={{ 
                                                                    borderRadius: '10px',
                                                                    fontWeight: '600',
                                                                    padding: '8px 12px',
                                                                    minWidth: '40px',
                                                                    background: totalPages === this.state.currentPage ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '',
                                                                    border: totalPages === this.state.currentPage ? 'none' : ''
                                                                }}
                                                            >
                                                                {totalPages}
                                                            </Button>
                                                        );
                                                    }

                                                    return pages;
                                                })()}
                                                
                                                <Button 
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => this.handlePageChange(this.state.currentPage + 1)}
                                                    disabled={this.state.currentPage === totalPages}
                                                    style={{ 
                                                        borderRadius: '10px',
                                                        fontWeight: '600',
                                                        padding: '8px 15px'
                                                    }}
                                                >
                                                    التالي
                                                </Button>
                                                
                                                <Button 
                                                    variant="outline-primary"
                                                    size="sm"
                                                    onClick={() => this.handlePageChange(totalPages)}
                                                    disabled={this.state.currentPage === totalPages}
                                                    style={{ 
                                                        borderRadius: '10px',
                                                        fontWeight: '600',
                                                        padding: '8px 15px'
                                                    }}
                                                >
                                                    الأخيرة
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            )
        }
        else {
            return (<Login />)
        }
    }
}

export default Category;